export default "__VITE_ASSET__CzL35HY0__"